module.exports = __webpack_public_path__ + "static/img/hh-medical.9a0d4414.png";